import styled, { css } from "styled-components";
import { color, font } from "src/styles/variables";
import formErrorIcon from "src/assets/images/icons/form-error.png";
import formSuccessIcon from "src/assets/images/icons/form-success.png";

const inputElCSSStyles = (styles) => css`
  ${styles};
`;

export const FormSection = styled.section`
  margin-bottom: 20px;
  ${({ emphasis }) =>
    emphasis &&
    `
    padding: 20px;
    background-color: ${color.blueishLightGrey};
    border: 1px solid ${color.blueishGrey};
    border-radius: 10px;
  `};
  ${({ css }) => css};
`;

export const FormSectionTitle = styled.h2`
  line-height: 1.25;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const ErrorList = styled.ul`
  color: ${color.torchRed};
  display: block;
  font-family: ${font.primary};
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  li:first-child {
    margin-top: 0.5em;
  }
  li {
    margin-bottom: 20px;
  }
`;

export const SelectWrapper = styled.div`
  flex-grow: 1;
  position: relative;
  :after {
    content: "";
    position: absolute;
    top: calc(50% - 2px);
    right: 12px;
    border: 7px solid transparent;
    border-top-color: ${color.midGrey};
    pointer-events: none;
  }
  ${({ css }) => css};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  & > button,
  & > a {
    margin: 10px;
    @media (max-width: 499px) {
      width: 100%;
    }
  }
`;

export const LabelEl = styled.label`
  display: block;
  font-size: 12px;
  height: 0;
  top: 2px;
  left: 17px;
  opacity: 0;
  overflow: visible;
  pointer-events: none;
  position: relative;
  z-index: 1;
  transform: translateY(24px);
  transition: opacity 0.2s, transform 0.2s;
  ${({ float }) => float && labelFloatStyles};
`;
const labelFloatStyles = css`
  opacity: 0.7;
  transform: translateY(14px);
`;

const inputStyles = {
  baseStyles: css`
    appearance: none;
    text-decoration: none;
    font-family: ${font.primary};
    font-weight: 400;
    font-style: normal;
    background-color: transparent;
    background-image: none;
    border: 0;
    border: 2px solid ${color.darkGrey};
    border-radius: 5px;
    color: ${color.black};
    display: block;
    font-size: 16px;
    height: auto;
    padding: 18px 14px 18px;
    line-height: 1.2em;
    margin-top: 10px;
    position: relative;
    width: 100%;
    transition: padding 0.2s ease;
    ${({ hasValue }) =>
      !!hasValue &&
      `
      padding: 26px 14px 10px;
    `};
  `,
  validStyles: css`
    background-image: url(${formSuccessIcon});
    background-repeat: no-repeat;
    background-position: right 22px top 50%;
    padding-right: 40px;
  `,
  invalidStyles: css`
    background-image: url(${formErrorIcon});
    background-repeat: no-repeat;
    background-position: right 22px top 50%;
    padding-right: 40px;
    border-color: ${color.torchRed};
    color: ${color.torchRed};
  `,
};

export const InputEl = styled.input`
  ${inputStyles.baseStyles};
  ${({ type, isValid }) =>
    type === "date" &&
    `text-transform: uppercase; color: ${
      isValid ? color.black : color.darkGrey
    }`};
  ${({ isValid }) => isValid && inputStyles.validStyles};
  ${({ isInvalid }) => isInvalid && inputStyles.invalidStyles};
  ${({ hideIsValidIcon }) => (hideIsValidIcon ? "background-image: none" : "")};
  ${({ disabled }) =>
    disabled && `background-color: ${color.dustyGrey}; cursor: not-allowed;`};
  ${({ css }) => css && inputElCSSStyles(css)};
`;

export const SelectEl = styled.select`
  ${inputStyles.baseStyles};
  border-color: ${color.midGrey};
  padding-right: 48px;
  ${({ isValid }) => isValid && inputStyles.validStyles};
  ${({ isInvalid }) => isInvalid && inputStyles.invalidStyles};
  ${({ disabled }) =>
    disabled &&
    `
    color: ${color.silverChalice};
    cursor: not-allowed;
  `};
  background-position-x: calc(100% - 28px);
`;

export const TextAreaEl = styled.textarea`
  ${inputStyles.baseStyles};
  padding-right: 15px;
  min-height: 8em;
  ${({ isValid }) => isValid && inputStyles.validStyles};
  ${({ isInvalid }) => isInvalid && inputStyles.invalidStyles};
  ${({ css }) => css && inputElCSSStyles(css)};
`;
